export enum TaxationSystemEnum {
  NDFL = 'NDFL',
  NPD = 'NPD',
  OSN = 'OSN',
  PATENT = 'PATENT',
  USN = 'USN',
}
